// components/VolunteerList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const VolunteerList = () => {
  const [volunteers, setVolunteers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchVolunteers();
  }, []);

  const fetchVolunteers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/api/volunteers`);

      // ✅ Laravel returns { message: '...', data: [...] }
      if (response.data && Array.isArray(response.data.data)) {
        setVolunteers(response.data.data);
      } else {
        setVolunteers([]);
      }
    } catch (err) {
      setError('Failed to fetch volunteers');
      console.error('Error fetching volunteers:', err);
    } finally {
      setLoading(false);
    }
  };

  const deleteVolunteer = async (id) => {
    if (window.confirm('Are you sure you want to delete this volunteer?')) {
      try {
        await axios.delete(`${API_BASE_URL}/api/volunteers/${id}`);
        fetchVolunteers(); // Refresh the list
        alert('Volunteer deleted successfully!');
      } catch (err) {
        console.error('Error deleting volunteer:', err);
        alert('Failed to delete volunteer');
      }
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) return <div className="text-center py-8">Loading volunteers...</div>;
  if (error) return <div className="alert alert-error">Error: {error}</div>;

  return (
    <div className="volunteer-list p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Volunteers ({volunteers.length})</h2>
        <button onClick={fetchVolunteers} className="btn btn-outline btn-sm">
          Refresh
        </button>
      </div>

      {volunteers.length === 0 ? (
        <div className="text-center py-8 bg-base-100 rounded-lg">
          <p className="text-lg">No volunteers found.</p>
        </div>
      ) : (
        <div className="overflow-x-auto bg-base-100 rounded-lg shadow">
          <table className="table table-zebra w-full">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Skills</th>
                <th>Reason</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {volunteers.map((volunteer) => (
                <tr key={volunteer.id}>
                  <td>
                    <div className="font-semibold">
                      {volunteer.first_name} {volunteer.last_name}
                    </div>
                  </td>
                  <td>{volunteer.email}</td>
                  <td className="font-mono text-sm">{volunteer.mobile}</td>
                  <td>
                    {volunteer.skills ? (
                      <span className="badge badge-info badge-sm">{volunteer.skills}</span>
                    ) : (
                      <span className="text-base-content/50">Not specified</span>
                    )}
                  </td>
                  <td>
                    {volunteer.reason ? (
                      <div className="text-sm truncate" title={volunteer.reason}>
                        {volunteer.reason}
                      </div>
                    ) : (
                      <span className="text-base-content/50">Not specified</span>
                    )}
                  </td>
                  <td className="text-sm text-base-content/70">
                    {formatDate(volunteer.created_at)}
                  </td>
                  <td>
                    <button
                      onClick={() => deleteVolunteer(volunteer.id)}
                      className="btn btn-error btn-sm"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default VolunteerList;
